import React from 'react';
import i18n from 'i18next';
import { ChevronRight } from 'react-feather';

const MenuDrawerItem = ({ menu, onClick }) => {
    const name =
        menu.names?.find((item) => item.langCode === i18n.language)?.name ||
        menu.names?.[0]?.name ||
        '';

    return (
        <div
            onClick={onClick}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                padding: '14px 20px',
                cursor: 'pointer',
                borderBottom: '1px solid #f3f4f6',
                transition: 'background .12s',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = '#f9fafb')}
            onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
        >
            <span
                style={{
                    fontSize: 15,
                    fontWeight: 500,
                    color: '#111827',
                    letterSpacing: '-0.01em',
                }}
            >
                {name}
            </span>
            {menu.children?.length > 0 && <ChevronRight size={16} color="#9ca3af" />}
        </div>
    );
};

export default MenuDrawerItem;
